import type {
  KnowledgeBasePageQuery,
  KnowledgeBasePageQueryVariables,
  KnowledgeBase,
  KnowledgeBaseQuery,
  FetchLatestKnowledgeBaseQuery,
  FetchLatestKnowledgeBaseQueryVariables,
} from '@edwin-group/people-graphql';
import requestHandler from '../requestHandler';
import { initializeApollo } from '../lib/apollo-client';
import {
  QUERY_FETCH_KNOWLEDGE_BASE_PAGE,
  QUERY_KNOWLEDGE_BASE,
  QUERY_FETCH_LATEST_KNOWLEDGE_BASES,
} from '@edwin-group/people-graphql';

export const fetchKnowledgeBasePage = async () => {
  const apolloClient = initializeApollo();
  const { data, error } = await requestHandler(
    apolloClient.query<KnowledgeBasePageQuery, KnowledgeBasePageQueryVariables>({
      query: QUERY_FETCH_KNOWLEDGE_BASE_PAGE,
    }),
  );

  if (error) {
    console.error('Error fetching knowledgebase', error);
    return { page: null };
  }

  return {
    page: data?.knowledgeBasePage,
    knowledgeBaseTypes: data?.knowledgeBaseCategories,
  };
};

export const fetchKnowledgeBase = async (slug: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<KnowledgeBaseQuery>({
      query: QUERY_KNOWLEDGE_BASE,
      fetchPolicy: 'cache-first',
      variables: {
        slug: [slug],
      },
    }),
  );

  if (error) {
    console.error('Error fetching knowledgebase', error);
    return { knowledgebase: null };
  }

  if (!data?.knowledgeBases?.data.length) {
    return { knowledgebase: null };
  }

  return {
    knowledgebase: data?.knowledgeBases?.data[0],
  };
};

export const fetchRelatedContent = async (slug: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchLatestKnowledgeBaseQuery, FetchLatestKnowledgeBaseQueryVariables>({
      query: QUERY_FETCH_LATEST_KNOWLEDGE_BASES,
      fetchPolicy: 'cache-first',
      variables: {
        slug: [slug],
      },
    }),
  );

  if (error) {
    console.error('Error fetching knowledgebase', error);
    return { knowledgebase: null };
  }

  return {
    knowledgebases: data?.knowledgeBases?.data as KnowledgeBase[],
  };
};

export interface SearchTabFilters {
  kinds?: string[];
  search?: string;
  trait?: string;
  subTrait?: string;
}
